import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, ViewChild  } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'app/shared/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent, PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-add-enrolment',
  templateUrl: './add-enrolment.component.html',
  styleUrls: ['./add-enrolment.component.scss']
})
export class AddEnrolmentComponent implements OnInit {

  // @ViewChild('telPhone') inputName;

    selectedValue:any=[];
    enrolmentModel={
      name:'',
      email:'',
      phone:'',
      college:'',
      student:[{id:''}],
      coursecatinterest_id:'',
      skillsinterest_id:[],
      course_id: '',
      batch_id: '',
      discounts_ids: '',
      total_fees: '',
      discount_amounts: '',
      net_fees: '',
      transaction_id: '',
      hunting_by: '',
      farming_by: '',
      status: '',
      payment_status:'',
      created_by: '',
      lastmodified_by: '',
      notes: '',
      admin_notes: '',
      user_id: { _id: '' },
      payable_amount: '',
      next_payment_date:"",
      date_of_joining:'',
      goal:'',
      team:'',
      learning_mode:'',
      next_action:null,
      last_activedate:"",
      lastresponse:""
    }
    
    paymentModeId='631ada2ace5c666542591bf6'
    paymentMode=[]
    selectedPaymentMode=null
    enrolmentId: any
    paid_amount: any;
    categoryList=[];
    selectedCategory=''
    skillTags:string[]=[];
    skillList=[];
    selectedHuntingBy = null;
    selectedFarmingBy = null;
    usersList:[]
    goal=null;
    team=null;
    goalList=[];
    teamList=[];
    courseList = []
    batchList = [];
    selectedBatch = null
    selectedBatch_schedule = null

    selectedCourse: "";
    enrolmentForm: FormGroup;
    collegeList=[];
    selectedCollege=null
    discountList = []
    min_next_payment_date: any
    selectedDiscount: string[] = [];
    pamentStatusList = [
      // { name: 'pending' },
      { name: 'received',label:'Payment Received' },
      { name: 'due',label:'Payement Due' },
      // { name: 'completed',label:'Completed' },
      // { name: 'left',label:'Left' },
    ]
    statusList = [
      // { name: 'pending' },
      { name: 'enrolled',label:'Enrolled' },
      { name: 'pending',label:'Pending' },
      { name: 'completed',label:'Completed' },
      { name: 'left',label:'Left' },
    ]
    public user = {
      p1: 'college',
      p2: 'batch'
    }
    selectedPaymentStatus = 'due'
    selectedStatus = 'enrolled'
    catId='6319d5025ab9e462a96cfbba'
    skillId='6319d3595ab9e462a96cfb06'
    goalId = '631ad878ce5c666542591bd4'
    teamId = '631ad9b6ce5c666542591be9'
    batchId = '6319d2985ab9e462a96cfae0'
    enrolledResData:any;
    emailPhoneValid:boolean = true;
    phoneAlreadyExist=''
    emailAlreadyExist:boolean = false
    emailCheck = new FormControl(Validators.required,Validators.email);
    phoneCheck = new FormControl('',Validators.required)
    businessTypeCompany_Id=''
    businessTypeCollege_Id='6325cdefbc4b543c7a2429a4'
    learningList=[]
    learningModeId='631ad8abce5c666542591bd9'
    selectLearningMode=null
    enrolment_id:any
    student_id:any
    name:any
    email:any
    isExisting_user :boolean =false
    agency=null
    agency_List=[
      { name:'Meander Software' , _id:'Meander_Software'},
      { name:'Vlogic Labs', _id:'Vlogic_Labs'},
      { name:'Drawtopic', _id:'Drawtopic'},
    ]
    list_type_cat_id:any
    list_type =[]
    selected_check_list = null
    sprint_id:any

    nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
    nextactionList = []
    selected_mentor :string[]=[]
    selected_buddy :string[]=[]
    batchSchedule_list =[]
    env_url = environment.name
    constructor(private ref: ChangeDetectorRef,
                private apiService:ApiService,public toastr: ToastrService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,
                private spinner: NgxSpinnerService,
                private route: Router) { }
    onNameChange(value: string) {
      this.name = value;
    }
    onEmailChange(value: string) {
      this.email = value;           
      this.checkEnrollment(this.name,this.email)
    }
    ngOnInit(): void {
      this.agency = 'Meander_Software'
      this.selectedHuntingBy = '63358024efa8a87882968210';
      this.selectedFarmingBy = '63358024efa8a87882968210';
      this.goal='6325ccdbbc4b543c7a24294f';
      this.team='6325cd6cbc4b543c7a242988';
      this.selectLearningMode='6325cd99bc4b543c7a24298f'
      
      this.emailCheck.valueChanges.subscribe((value) => {
        if (this.validateEmail(value)) { this.checkEmailPhone(value,this.enrolmentModel.phone) }
      })
      this.phoneCheck.valueChanges.subscribe((value) => {
        if (value && value.length>=10) { this.checkEmailPhone(this.enrolmentModel.email,value) }
      })
    
  
      this.getUsers();
      this.getSkillTagByCategory();
      this.getTeamTagByCategory();
      this.getGoalTagByCategory();
      this.getNextActionTags()
      this.getCheckListType()
      this.getBatchList();
      this.getBatchSchedule()
      this.getAllBatch();
      this.getAllCollege();
      this.getTagByCategory();
      this.getCourseList();
      this.getDiscountList();
      this.getModeTagByCategory()
      this.paymentModeList();
      // this.getCategoryById()
      this.min_next_payment_date=new Date().toISOString().slice(0, 10);
    
    }
    ngAfterViewInit() {
      setTimeout(() => {
        this.ref.detectChanges();
      }, 100);
  
    }
    getCheckListType(){
      this.apiService.getTagByTagCatgoryId('65268dbf37d5731c9401d3fe').subscribe((res:any)=>{
        this.list_type_cat_id = res?.data?.filter(item => item.name == 'quick' )
        if(this.list_type_cat_id){
          this.getCheckList()
        }
      })
    }
    getCheckList() {
      this.apiService.getAllChecklist(1, 100,this.list_type_cat_id[0]?._id).subscribe((res: any) => {
        this.list_type = res?.data?.items
      })
    }
    getCheckListId(event){
      this.selected_check_list
      if(this.selected_check_list){
        this.apiService.getSprintByChecklistId(this.selected_check_list).subscribe((res:any)=>{
          this.sprint_id = res?.data[0]?.sprint[0]._id
        })
      }
    }
    getAllCollege(){
      this.apiService.getBusinessByTypeId('6325cdefbc4b543c7a2429a4').subscribe((res:any)=>{
        this.collegeList=res.data
      })
    }
    // checkStudentExists(data){
    //   this.apiService.studentFilter(data).subscribe((res:any)=>{
    //     if(res.statusCode === 200){
    //       return true
    //     }
    //     else{
    //       return false
    //     }
    //   })
    // }
    updateBusiness(id, data) {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      let model = {
        is_activated: data
      }
      this.apiService.updateBusiness(id, model).subscribe((res: any) => {
        if (res.isSuccess) {
          this.getAllCollege()
          this.spinner.hide()
        }
      })
    }
    checkIfCollegeActivated(collegeId) {
      const index = this.collegeList.findIndex(x => x._id == collegeId)
      if (index >= 0) {
        return this.collegeList[index].is_activated
      }
      return false
    }
    getCollegeId(event: any) {
      this.selectedCollege
    }
    getUsers() {
      this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
        this.usersList = res.items
      })
    }
    getHuntId(event: any) {
      this.selectedHuntingBy
    }
    getFarmId(event: any) {
      this.selectedFarmingBy

    }
   
    // getCategoryList(){
    //   this.apiService.getAllCategory(1,100).subscribe((res:any)=>{
    //     console.log('category list res',res)
    //     this.categoryList=res.data.items
    //   })
    //  }
    getTagByCategory() {
      this.apiService.getTagByTagCatgoryId(this.catId).subscribe((res: any) => {
        this.categoryList = res.data
      })
    }
  
    getSkillTagByCategory() {
      this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
        this.skillList = res.data
      })
    }
  
    getGoalTagByCategory() {
      this.apiService.getTagByTagCatgoryId(this.goalId).subscribe((res: any) => {
        this.goalList = res.data
      })
    }
    getGoalId(event){
      this.goal
    }
    getTeamTagByCategory() {
      this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
        this.teamList = res.data
      })
    }
    getTeamId(event){
      this.team
    }
    getModeTagByCategory(){
      this.apiService.getTagByTagCatgoryId(this.learningModeId).subscribe((res:any)=>{
        this.learningList=res?.data
      })
    }
    getModeId(event:any){
      this.selectLearningMode
    }
  
    getBatchList() {
      this.apiService.getBatchListByStatus('64423a83fca16673d960a454').subscribe((res: any) => {
        this.batchList = res.data.items
      })
    }
    getBatchSchedule() {
      let tag_cat_id
      if(this.env_url ==='dev'){
        tag_cat_id ='681c9516a637a836a5f8863b'
      }
      if(this.env_url ==='prod'){
        tag_cat_id ='681c9e22e9c3d0fc4b93394b'
      }
      this.apiService.getTagByTagCatgoryId(tag_cat_id).subscribe((res: any) => {
        this.batchSchedule_list = res?.data
      })
    }
    getBatchId(event: any) {
      this.selectedBatch
    }
    getBatchScheduleId(event: any) {
      this.selectedBatch_schedule
    }
    getCategoryId(event: any) {
      this.selectedCategory
    }
    //  getTagList(){
    //   this.apiService.getTagsList(1,100).subscribe((res:any)=>{
    //     console.log('tags list res',res)
    //     this.tagsList=res.data.items
    //   })
    // }
  
    getCourseList() {
      this.apiService.getCourseList(1, 1000).subscribe((res: any) => {
        this.courseList = res.data.items
      })
    }
    getCourseId(event: any) {
      this.selectedCourse
      this.getCoursebyId()
    }
    getCoursebyId() {
      this.apiService.getCourseById(this.selectedCourse).subscribe((res: any) => {
        this.enrolmentModel.total_fees = res?.data[0]?.total_fees
        this.enrolmentModel.net_fees = res?.data[0]?.total_fees
      })
    }
    getDiscountList() {
      this.apiService.getAllDiscounts(1, 100).subscribe((res: any) => {
        this.discountList = res.data.items
      })
    }
    getDiscountByCourseId() {
      if (this.selectedDiscount.length < 1) {
        this.enrolmentModel.net_fees = this.enrolmentModel.total_fees;
        this.paid_amount = this.enrolmentModel.total_fees;
      } else {
        let body = {
          courseId: this.selectedCourse,
          discountId: this.selectedDiscount
        }
        this.apiService.getDiscountByCourseId(body).subscribe((res: any) => {
          this.enrolmentModel.total_fees = res.data.courseFee;
          this.enrolmentModel.net_fees = res.data.netFees;
          this.paid_amount = res.data.netFees;
        })
      }
    }
  
    //  getDiscountById(){
    //   this.apiService.getDiscountById(this.selectedDiscount).subscribe((res:any)=>{
    //     console.log('discountby id',res)
    //   })
    //  }
    getDiscountId(event: any) {
      this.selectedDiscount
      // this.getDiscountById()
      this.getDiscountByCourseId()
    }
    //  getBatchList(){
    //   this.apiService.getBatchList(1,100).subscribe((res:any)=>{
    //     console.log('batch list',res)
    //     this.batchList=res.data.items
    //   })
    //  }
    getAgencyId(event: any){
      this.agency
    }
    createEnrolment() {
     
        let body={
          name:this.enrolmentModel.name,
          email:this.enrolmentModel.email,
          phone:this.enrolmentModel.phone,
          college:this.selectedCollege,
          coursecatinterest_id:this.selectedCategory,
          skillsinterest_id:this.skillTags,
        }
          this.apiService.createEnrolment(body).subscribe((res:any)=>{
           if(res.statusCode === 200){
            this.enrolment_id=res?.data._id
            this.student_id=res?.data?.user_id
           }
           else{
            this.toastr.error(res.error)
           }
          })
     
        }
    submit() {
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      let body = {
        goal: this.goal,
        team: this.team,
        hunting_by: this.selectedHuntingBy,
        farming_by: this.selectedFarmingBy,
        course_id: this.selectedCourse,
        batch_id: this.selectedBatch,
        total_fees: this.enrolmentModel.total_fees,
        net_fees: this.enrolmentModel.net_fees,
        discounts_ids: this.selectedDiscount,
        payable_amount: this.enrolmentModel.payable_amount,
        status: this.selectedStatus,
        payment_status:this.selectedPaymentStatus,
        notes: this.enrolmentModel.notes,
        admin_notes: this.enrolmentModel.admin_notes,
        next_payment_date:this.enrolmentModel.next_payment_date,
        date_of_joining:this.enrolmentModel.date_of_joining,
        agency: this.agency,
        next_action: this.enrolmentModel.next_action,
        last_activedate: this.enrolmentModel.last_activedate,
        lastresponse: this.enrolmentModel.lastresponse,
        learning_mode : this.selectLearningMode,
        checklist: '6545195d15950cbce9ddc5ad',
        sprint : '6545195d15950cbce9ddc5af',
        // checklist : "6545db054ae8739ffc6f922a",
        // sprint : "6545db054ae8739ffc6f922c",
        buddy_id : this.selected_buddy,
        mentor_id : this.selected_mentor,
        batch_schedule : this.selectedBatch_schedule
      }
  
        this.apiService.updateEnrolment( this.enrolment_id,body).subscribe((res: any) => {
          this.spinner.hide()
          if (res.isSuccess === true) {
            this.enrolledResData=res.data
            this.sendMail(res?.data?.email)
            if(this.paid_amount>0){
              this.transaction();
            }
            this.toastr.success('Created Successfully', res.message)
            swal.fire({
              title: "Success!",
              text: `${this.enrolmentModel.name} login password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
              icon: "success",
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false,
            });
            // this.route.navigate(['/enrollments/enrollment-list'])
            history.back()
          }
          else {
            this.toastr.error(res.error)
          }
        })
      
     
    }
    paymentModeList(){
      this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
        this.paymentMode = res.data
      })
    }
    getPaymentModeId(event:any){
      this.selectedPaymentMode
    }
    transaction() {
      let body = {
        net_amount: this.enrolmentModel.net_fees,
        paid_amount: this.paid_amount,
        course_id: this.selectedCourse,
        discounts_ids: this.selectedDiscount,
        student: this.student_id,
        entity_id: this.enrolment_id,
        payment_status:this.selectedPaymentStatus,
        mode:this.selectedPaymentMode
      }
      this.apiService.createTransaction(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          // this.toastr.success(res.message)
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
    //  openContent() {
    // const modalRef = this.modalService.open(PopupModalContent);
    // modalRef.componentInstance.userName = 'tetssysgu'
    // modalRef.result.then((data) => {
    //   console.log("mode close>>>>>>>>>>>>",data)
    //   if(data=="success"){
    //     this.getTransactionsByUserId()
    //   }
    //   // on close
    // }, (reason) => {
    //   // on dismiss
    // });
    // }
    // getAllBusinessList() {
    //   this.apiService.getBusinessList(1, 10).subscribe((res: any) => {
    //     console.log('business list ==', res)
    //   })
    // }
    getAllBatch() {
      this.apiService.getBatchList(1, 10).subscribe((res: any) => {
      })
    }
    goToPage(){
      this.route.navigate(['/business/add'])
    }
    openContent(data: any) {
      let number = data;
      const modalRef = this.modalService.open(PopupModalComponent);
      switch (number) {
        case 1:
          modalRef.componentInstance.user = this.user.p1;
          modalRef.result.then((data) => {
            if (data == "success") {
              this.getAllCollege()
            }
            // on close
          }, (reason) => {
            // on dismiss
          });
          break;
        case 2:
          modalRef.componentInstance.user = this.user.p2;
          modalRef.result.then((data) => {
            if (data == "success") {
              this.getAllBatch()
            }
            // on close
          }, (reason) => {
            // on dismiss
          });
          break;
      }
    }
  // --------- Check Email Exist ---------------------
  validateEmail (emailAdress){
    let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailAdress.match(regexEmail)) {
      return true; 
    } else {
      return false; 
    }
  }
  checkEmailPhone(email,phone){
    let model={
      email:email,
      phone:phone,
    }
    this.apiService.checkPhoneExists(phone).subscribe((res:any)=>{
      if(res.statusCode === 200 ){
        this.phoneAlreadyExist=res.data
      }
    })
  //   this.apiService.checkIfAlreadyExist(model).subscribe((res:any)=>{
  //     if(res.isSuccess){
  //       this.emailPhoneValid =true
  //       this.phoneAlreadyExist = false
  //       this.emailAlreadyExist = false
  //     }
  // else{
  //   this.emailPhoneValid =false
  //   // this.openModal()
  //   if(res.error=='Phone number already exists'){
  //     this.phoneAlreadyExist = true
  //     this.emailAlreadyExist = false
  //   }
  //   // else{
  //   //   this.emailAlreadyExist = false
  //   // }
  //   if(res.error=='Email already exists'){
  //     this.emailAlreadyExist = true
  //     this.phoneAlreadyExist = false
  //   }
  // }  
  // })
  }
  checkEnrollment(name,email){
    let body ={
      name: name,
      email: email
    }

    this.apiService.checkUserEnrollment(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.isExisting_user =true
        this.enrolmentModel.phone = res?.data[0]?.phone

      this.selectedCollege = res?.data[0]?.enrolment?.college
      this.enrolmentModel.college = this.selectedCollege

      this.selectedCategory = res?.data[0]?.enrolment?.coursecatinterest_id

        this.selectedHuntingBy = res?.data[0]?.enrolment?.hunting_by
        this.enrolmentModel.hunting_by = this.selectedHuntingBy
      
        this.selectedFarmingBy = res?.data[0]?.enrolment?.farming_by
        this.enrolmentModel.farming_by = this.selectedFarmingBy

        this.goal = res?.data[0]?.enrolment?.goal
        this.enrolmentModel.goal = this.goal

        this.selectLearningMode = res?.data[0]?.enrolment?.learning_mode
        this.enrolmentModel.learning_mode =  this.selectLearningMode

        this.team = res?.data[0]?.enrolment?.team
        this.enrolmentModel.team = this.team
    
      this.skillTags = res?.data[0]?.enrolment?.skillsinterest_id.map(item=>{return item})
      this.enrolmentModel.skillsinterest_id = this.skillTags
      }
    })
  }
  sendMail(email){
    if(email){
      this.apiService.sendMail(email).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success(res.message)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  }
  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res?.data
    })
  }
  getChangeNextAction(event) {
    this.enrolmentModel.next_action
  }
  getMentorId(event){
    this.selected_mentor
  }
  getBuddyId(event){
    this.selected_buddy
  }
  }
  
  